import { render } from "./OptionsForSurveyAnswers.vue?vue&type=template&id=1e7a58fe"
import script from "./OptionsForSurveyAnswers.vue?vue&type=script&lang=js"
export * from "./OptionsForSurveyAnswers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])